export const getMenuItems = () => {
  // Items do menu ação
  return [
    { key: "1", label: "Exportar" },
    { key: "2", label: "Marcar Etiqueta" },
  ];
};
